import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { emailSignupRequest } from "../../actions/UserActions";
import { getUserState } from "../../utils/userReduxSelector";
import { INVALID_EMAIL_ADDRESS } from "../../utils/errorMessages";
import { usePrevious } from "../../utils/hooks";

// Components
import IconButton from "../Atoms/IconButton";
import Paragraph from "../Atoms/Paragraph";
import Icon from "../Atoms/Icon";
import ErrorMessage from "../Forms/ErrorMessage";
import { TrackingContext } from "../Utils/TrackingWrapper";

// Stylesheet
import "./LeadGenForm.scss";

const renderErrors = (displayError) => {
  if (displayError) {
    return <ErrorMessage>{INVALID_EMAIL_ADDRESS}</ErrorMessage>;
  }

  return null;
};

const Form = () => {
  const [emailValue, setEmailvalue] = useState("");
  const {
    trackingActions: { trackEmailSignup },
  } = useContext(TrackingContext);
  const storeEmailValue = (evt) => setEmailvalue(evt.target.value);
  const { sending, errors } = useSelector((state) => getUserState(state));
  const dispatch = useDispatch();
  const submitForm = (evt) => {
    evt.preventDefault();

    if (!sending) {
      trackEmailSignup();
      dispatch(emailSignupRequest({ email: emailValue }));
    }
  };

  return (
    <form
      method="POST"
      className="lead_gen_form form"
      aria-label="form"
      onSubmit={submitForm}
    >
      <div className="form_fields">
        <label
          htmlFor="lead_gen_email_field"
          className="is_accessible_and_hidden"
        >
          Email Address:
        </label>

        <input
          id="lead_gen_email_field"
          type="email"
          placeholder="Email Address"
          className="email_field"
          onChange={storeEmailValue}
          value={emailValue}
        />
        <IconButton className="submit_button" type="submit">
          <Icon color="white" materialIconName="arrow_right_alt" />
        </IconButton>
      </div>

      {renderErrors(errors.newsletterSignup)}
    </form>
  );
};

export const LeadGenForm = () => {
  const {
    sending,
    errors,
    data: { value },
    signupRequestSent,
  } = useSelector((state) => getUserState(state), shallowEqual);
  const prevSubmittingState = usePrevious(sending);
  const {
    trackingActions: { trackLeadGenSignup },
    pageUrl,
  } = useContext(TrackingContext);

  useEffect(() => {
    // Once done submitting, if there is
    // a successful signup, then fire tracking
    if (prevSubmittingState && !sending && value) {
      trackLeadGenSignup({ pageUrl });
    }
  }, [prevSubmittingState, sending, value, pageUrl, trackLeadGenSignup]);

  if (signupRequestSent && !errors.newsletterSignup) {
    return (
      <Paragraph
        className="success_message"
        data-testid="lead_gen_success_message"
      >
        Thanks! Get ready for better sleep
      </Paragraph>
    );
  }

  return <Form />;
};
